<template>
    <div class="bets-list">
        <BetsCarousel
            title="Nejblíže k naplnění"
            :data="syndicatesClosestToFilling"
            v-if="syndicatesClosestToFilling && syndicatesClosestToFilling.length"
        />
        <BetsCarousel
            title="Největší sázenky"
            :data="syndicatesBiggest"
            v-if="syndicatesBiggest && syndicatesBiggest.length"
        />
        <BetsCarousel
            title="Na nejbližší slosování"
            :data="syndicatesClosestDraw"
            v-if="syndicatesClosestDraw && syndicatesClosestDraw.length"
        />
        <div class="bs-container">
            <div class="bs-row justify-content-center">
                <a class="btn btn-primary" href="trziste-sazenek" v-html="syndicatesCountLabel"></a>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { SyndicatePreview } from "@/lotteries/model/syndicates/syndicate-preview";
import SyndicatesCounts from "@/lotteries/model/syndicates/syndicates-counts";
import {
    fetchBiggestSyndicates,
    fetchClosestSyndicates,
    fetchClosestToFillingSyndicates,
    fetchSyndicatesCounts,
} from "@/lotteries/services/syndicates/syndicates-api";
import { computed, defineComponent, onMounted, Ref, ref, watch } from "vue";
import BetsCarousel from "./bets-carousel.vue";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { StringUtils } from "@sazka/utils/string-utils";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { SyndicateDetail } from "@/lotteries/model/syndicates/syndicate-detail";
import { SyndicatesAnalytics } from "@/lotteries/services/syndicates/analytics-syndicates";

export default defineComponent({
    name: "LandingPageBets",
    components: {
        BetsCarousel,
    },
    props: {
        suppressLoading: Boolean,
    },

    setup(props) {
        const suppress = ref(props.suppressLoading === true);

        const syndicatesCounts = ref<SyndicatesCounts | null>(null);
        const counts = computed(() => {
            return syndicatesCounts.value
                ? syndicatesCounts.value.sportka + syndicatesCounts.value.sportkaMh + syndicatesCounts.value.eurojackpot
                : 0;
        });
        watch(counts, (val) => {
            document.getElementById("syn-w-c").textContent = val.toString();
            if (val === 1) {
                document.getElementById("syn-w-c-l").textContent = "sázenka";
                return;
            }
            if (val > 1 && val < 5) {
                document.getElementById("syn-w-c-l").textContent = "sázenky";
                return;
            }
            document.getElementById("syn-w-c-l").textContent = "sázenek";
        });

        const syndicatesClosestToFilling = ref<SyndicatePreview[]>([]);
        const syndicatesBiggest = ref<SyndicatePreview[]>([]);
        const syndicatesClosestDraw = ref<SyndicatePreview[]>([]);

        const init = () => {
            if (suppress.value) return;

            Loader.show();

            const p1 = fetchSyndicatesCounts().then((data) => {
                syndicatesCounts.value = data;
            });

            const p2 = fetchClosestToFillingSyndicates().then((data) => {
                syndicatesClosestToFilling.value = data;
            });

            const p3 = fetchBiggestSyndicates().then((data) => {
                syndicatesBiggest.value = data;
            });

            const p4 = fetchClosestSyndicates().then((data) => {
                syndicatesClosestDraw.value = data;
            });

            Promise.all([p1, p2, p3, p4]).finally(() => Loader.hide());
        };

        init();

        eventBus.on(GlobalEvents.SyndicateDetailClosed, () => {
            if (suppress.value) {
                suppress.value = false;
                init();
            }
        });

        const updateSyndicates = (syndicates: Ref<SyndicatePreview[]>, updatedSyndicate: SyndicateDetail) => {
            syndicates.value.forEach((syn) => {
                if (syn.id === updatedSyndicate.id) {
                    syn.unsoldParts = updatedSyndicate.unsoldParts;
                }
            });
        };
        eventBus.on(GlobalEvents.SyndicateUpdated, (syndicateResponse) => {
            const updatedSyndicate = syndicateResponse as { response: SyndicateDetail; partsPerWager: number };
            updateSyndicates(syndicatesClosestToFilling, updatedSyndicate.response);
            updateSyndicates(syndicatesBiggest, updatedSyndicate.response);
            updateSyndicates(syndicatesClosestDraw, updatedSyndicate.response);
        });

        const syndicatesCountLabel = computed(() => {
            return `Procházet ${StringUtils.formatNumber(counts.value)}
            ${counts.value === 1 ? "otevřenou" : counts.value < 5 && counts.value > 1 ? "otevřené" : "otevřených"}
            <span class="d-none d-xs2-inline">
                ${
                    counts.value === 1
                        ? "skupinovou"
                        : counts.value < 5 && counts.value > 1
                        ? "skupinové"
                        : "skupinových"
                }
            </span>
            ${counts.value === 1 ? "sázenku" : counts.value < 5 && counts.value > 1 ? "sázenky" : "sázenek"}`;
        });

        onMounted(() => {
            SyndicatesAnalytics.pushHomePage();
        });

        return {
            syndicatesClosestToFilling,
            syndicatesBiggest,
            syndicatesClosestDraw,
            syndicatesCountLabel,
        };
    },
});
</script>
